export default "__VITE_ASSET__BviPLxJZ__"